import routerOptions0 from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/node_modules/.pnpm/nuxt@3.14.1592_@parcel+watcher@2.5.0_@types+node@25.0.3_eslint@9.39.2_jiti@2.7.0__ioredis@5.8_ux4w6bd7yb4gnzk34fiubdm3wa/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}